export default "__VITE_ASSET__0a76bdb8__"